import React, { useState } from "react";
import { actualKey } from "./lineupOptimizer";

const actionStyle = {
  padding: "0.4rem 0.65rem", borderRadius: 10,
  border: "1px solid rgba(148,163,184,0.55)", background: "#fff",
  fontWeight: 800, cursor: "pointer",
};

function downloadCsv(contract, result) {
  if (!contract || !result?.roundTrip?.valid || !result.csv) return;
  const url = URL.createObjectURL(new Blob([result.csv], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${contract.fileName.replace(/\.csv$/i, "")}-PWG-lineups.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export default function DraftKingsLineupResults({ contract, result, hidden, onBack, onToggleHidden, onClear, embedded = false, onPlayerAction, onReturnToPool }) {
  const lineups = result?.lineups || [];
  const [lineupIndex, setLineupIndex] = useState(0);
  if (!contract || !lineups.length) return null;
  const visibleLineups = embedded && lineups.length > 4 ? [lineups[Math.min(lineupIndex, lineups.length - 1)]] : lineups;

  return <section id="pwg-draftkings-lineups" style={{ width: "100%" }}>
    {!embedded && <header style={{
      position: "sticky", top: 0, zIndex: 25, background: "rgba(255,255,255,0.98)",
      border: "1px solid rgba(148,163,184,0.35)", borderRadius: 14,
      padding: 10, marginBottom: 12,
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
        <div style={{ fontFamily: "Georgia, serif", fontWeight: 800, fontSize: 20 }}>
          DraftKings NFL {contract.contestType === "SHOWDOWN" ? "Showdown" : "Classic"}{" "}
          <span style={{ color: "#64748b", fontWeight: 600 }}>{lineups.length} generated</span>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button type="button" style={actionStyle} onClick={onBack}>← Back to Props (Cards/Grid)</button>
          <button type="button" style={{ ...actionStyle, background: hidden ? "#fff" : "#0f172a", color: hidden ? "#111827" : "#fff" }} onClick={onToggleHidden}>{hidden ? "Show" : "Hide"}</button>
          <button type="button" style={actionStyle} onClick={onClear}>Clear</button>
          <button type="button" style={{ ...actionStyle, background: "#0f172a", color: "#fff" }} onClick={() => downloadCsv(contract, result)}>Export DraftKings CSV</button>
        </div>
      </div>
    </header>}

    {embedded && <div className="dkResultsActions"><button type="button" onClick={onReturnToPool}>Return to Player Pool</button><button type="button" onClick={onClear}>Clear</button><button type="button" onClick={() => downloadCsv(contract, result)}>Export DraftKings CSV</button></div>}

    {embedded && lineups.length > 4 && <nav className="dkLineupNav" aria-label="Lineup navigation"><button type="button" disabled={lineupIndex === 0} onClick={() => setLineupIndex((value) => Math.max(0, value - 1))}>Previous</button><strong>{lineupIndex + 1} / {lineups.length}</strong><button type="button" disabled={lineupIndex === lineups.length - 1} onClick={() => setLineupIndex((value) => Math.min(lineups.length - 1, value + 1))}>Next</button></nav>}

    {!hidden && <div className="dkResultCards" style={embedded ? undefined : { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 620px), 1fr))", gap: 14 }}>
      {visibleLineups.map((lineup, visibleIndex) => {
        const index = embedded && lineups.length > 4 ? lineupIndex : visibleIndex;
        const salary = lineup.slots.reduce((sum, { player }) => sum + player.salary, 0);
        const quality = lineup.slots.reduce((sum, { player }) => sum + player.pwgScore, 0);
        const enriched = lineup.slots.filter(({ player }) => player.matchStatus === "MATCHED").length;
        return <article className="lineup-card card dkLineupCard" key={index} aria-label={`DraftKings lineup ${index + 1}`} style={{ padding: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
            <strong style={{ fontSize: 18 }}>Lineup {index + 1}</strong>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", fontWeight: 800 }}>
              <span>Projected quality: {quality.toFixed(1)}</span>
              <span>Salary used: ${salary.toLocaleString()}</span>
              <span>Remaining: ${(contract.salaryCap - salary).toLocaleString()}</span>
              <span>PWG enriched: {enriched}</span>
              <span>DraftKings only: {lineup.slots.length - enriched}</span>
            </div>
          </div>
          <div className="dkLineupRows" style={{ display: "grid", gap: 8 }}>
            {lineup.slots.map(({ slot, player }, slotIndex) => {
              const captain = slot === "CPT";
              return <div className={`dkLineupRow ${captain ? "isCaptain" : ""}`} key={`${slot}-${slotIndex}`} data-roster-slot={slot}>
                <strong>{captain ? "★ CPT" : slot}</strong>
                <div><strong>{player.name}</strong><div style={{ color: "#64748b", fontSize: 12 }}>{player.position}</div></div>
                <div><strong>{player.team}</strong><div style={{ color: "#64748b", fontSize: 12 }}>{player.gameInfo || "Game unavailable"}</div></div>
                <div><strong>${player.salary.toLocaleString()}</strong><div style={{ color: "#64748b", fontSize: 12 }}>DK avg {Number(player.avgPoints).toFixed(1)}</div></div>
                <div><strong>{player.scoringSource}</strong>{player.matchStatus === "MATCHED" && <div style={{ color: "#1d4ed8", fontSize: 12 }}>PWG score {player.pwgScore.toFixed(1)}</div>}</div>
                {onPlayerAction && <div><button type="button" onClick={() => onPlayerAction(actualKey(player), "lock")}>Lock</button><button type="button" onClick={() => onPlayerAction(actualKey(player), "exclude")}>Exclude</button></div>}
              </div>;
            })}
          </div>
        </article>;
      })}
    </div>}
  </section>;
}

export { downloadCsv };
